export default function BlogPostSkeleton() {
    return <div>
        loading
    </div>
}